import api from "./api";

const boxService = {};
const boxEndpoint = "/boxes";

// GET boxes por institutionId
boxService.getBoxes = function (institutionId) {
  return api
    .get(boxEndpoint, { params: { institutionId } })
    .then((res) => res.data);
};

// POST create
boxService.createBox = function (box) {
  return api.post(boxEndpoint, box).then(({ data }) => data);
};

// DELETE
boxService.deleteBox = function (id) {
  return api.delete(`${boxEndpoint}/${id}`);
};

// (opcional) PUT update
boxService.updateBox = function (id, box) {
  return api.put(`${boxEndpoint}/${id}`, box).then(({ data }) => data);
};

export default boxService;
